<template>
    <v-container>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-row >
                        <v-col cols="12">
                            <h2 class="text-center">Suppliers</h2>
                        </v-col>
                    </v-row>

                    <v-row >
                        <v-col cols="12" sm="2" offset-sm="2">
                            <v-checkbox
                                label="Active Only"
                                v-model="activeOnly"
                            ></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="2">
                            <v-checkbox
                                label="Show Specimen Suppliers"
                                v-model="showSpecimenSuppliers"
                            ></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="2">
                            <v-checkbox
                                label="Show Venom Suppliers"
                                v-model="showVenomSuppliers"
                            ></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="2" offset-sm>
                            <v-btn
                                v-if="!auth.currentUserIsReadOnly()"
                                color="success"
                                block
                                @click="editSupplier({ Active: true })"
                            >
                                Add
                            </v-btn>
                        </v-col>
                    </v-row>

                    <v-row >
                        <v-col>
                            <v-data-table
                                :headers="headers"
                                :items="suppliers"
                                :loading="loading"
                                :sort-by.sync="pagination.sortBy"
                                :sort-desc.sync="pagination.sortDesc"
                                :items-per-page.sync="pagination.rowsPerPage"
                                :page.sync="pagination.page"
                                :footer-props="footerProps"
                                item-key="SupplierID"
                                must-sort
                            >
                                <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>

                                <template slot="item.MiscComments" slot-scope="props">
                                    <div class="commentColumn" v-if="props.item.MiscComments">{{ props.item.MiscComments }}</div>
                                </template>

                                <template slot="item.Active" slot-scope="props">
                                    <td>
                                        <v-icon v-if="props.item.Active" color="success">check</v-icon>
                                        <v-icon v-else color="error">close</v-icon>
                                    </td>
                                </template>

                                <template slot="item.IsVenomSupplier" slot-scope="props">
                                    <td>
                                        <v-icon v-if="props.item.IsVenomSupplier" color="success">check</v-icon>
                                        <v-icon v-else color="error">close</v-icon>
                                    </td>
                                </template>

                                <template slot="item.IsSpecimenSupplier" slot-scope="props">
                                    <td>
                                        <v-icon v-if="props.item.IsSpecimenSupplier" color="success">check</v-icon>
                                        <v-icon v-else color="error">close</v-icon>
                                    </td>

                                    <!-- <td v-if="props.item.IsSpecimenSupplier"><v-icon color="success">check</v-icon></td>
                                    <td v-if="!props.item.IsSpecimenSupplier"><v-icon color="error">close</v-icon></td> -->
                                </template>

                                <template slot="item.Edit" slot-scope="props">
                                    <td v-if="!auth.currentUserIsReadOnly()">
                                        <v-btn
                                            color="warning"
                                            block
                                            @click="editSupplier(props.item)"
                                        >
                                            Edit
                                        </v-btn>
                                    </td>
                                    <td v-else></td>
                                </template>

                                <template v-if="!loading" slot="no-data">
                                    <v-alert v-if="loadError" outlined :value="true" color="error" icon="error">
                                        {{loadError}}
                                    </v-alert>
                                    <v-alert v-if="!loadError" outlined :value="true" type="info">
                                        No results found
                                    </v-alert>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
        
        <v-dialog v-model="showEditDialog" transition="dialog-bottom-transition" :fullscreen="true">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-btn icon dark :disabled="saving" @click="cancelEditSupplier">
                        <v-icon large>close</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-toolbar-title v-if="editedSupplier && editedSupplier.SupplierID">Edit Supplier</v-toolbar-title>
                    <v-toolbar-title v-else>Add New Supplier</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        
                    </v-toolbar-items>
                </v-toolbar>
                <v-form @submit.prevent ref="editForm" v-model="editSupplierValid">
                    <v-row class="dialog-content">
                        <v-col cols="12" md="6" offset-md="3">
                            <v-row>

                                <v-col cols="12">
                                    <v-text-field
                                        clearable
                                        counter="100"
                                        maxlength="100"
                                        v-model="editedSupplier.SupplierName"
                                        :rules="[rules.required]"
                                        label="Supplier Name">
                                    </v-text-field>
                                </v-col>

                                <v-col cols="12">
                                    <v-select
                                        :items="geographicLocations"
                                        item-text="GeographicalLocationName"
                                        item-value="GeographicalLocationID"
                                        v-model="editedSupplier.GeographicalLocationID"
                                        label="Geographical Location"
                                        clearable
                                    ></v-select>
                                </v-col>

                                <v-col cols="12">
                                    <v-textarea 
                                        label="Miscellaneous Comments"
                                        v-model="editedSupplier.MiscComments"
                                        counter="250"
                                        maxlength="250" >
                                    </v-textarea>
                                </v-col>

                                <v-col cols="12">
                                    <v-checkbox
                                        label="Supplies Specimens"
                                        v-model="editedSupplier.IsSpecimenSupplier"
                                    >
                                    </v-checkbox>
                                </v-col>

                                <v-col cols="12">
                                    <v-checkbox
                                        label="Supplies Venom"
                                        v-model="editedSupplier.IsVenomSupplier"
                                        @change="isVenomSupplierChanged"
                                    >
                                    </v-checkbox>
                                </v-col>

                                <v-col cols="12" v-if="editedSupplier.IsVenomSupplier">
                                    <v-text-field
                                        clearable
                                        counter="100"
                                        maxlength="100"
                                        v-model="editedSupplier.ContactName"
                                        :rules="[rules.required]"
                                        label="Supplier Contact Name">
                                    </v-text-field>
                                </v-col>

                                <v-col cols="12" v-if="editedSupplier.IsVenomSupplier">
                                    <v-text-field
                                        clearable
                                        counter="100"
                                        maxlength="100"
                                        v-model="editedSupplier.ContactNumber"
                                        label="Supplier Contact Number">
                                    </v-text-field>
                                </v-col>

                                <v-col cols="12" v-if="editedSupplier.IsVenomSupplier">
                                    <v-text-field
                                        clearable
                                        counter="100"
                                        maxlength="100"
                                        v-model="editedSupplier.ContactEmail"
                                        label="Supplier Contact Email">
                                    </v-text-field>
                                </v-col>

                                <v-col cols="12" v-if="editedSupplier.IsVenomSupplier">
                                    <v-textarea
                                        clearable
                                        counter="500"
                                        v-model="editedSupplier.SupplierAddress"
                                        label="Supplier Contact Address">
                                    </v-textarea>
                                </v-col>

                                <v-col cols="12">
                                    <v-checkbox
                                        label="Active"
                                        v-model="editedSupplier.Active"
                                    >
                                    </v-checkbox>
                                </v-col>

                            </v-row>
                            <v-row  class="dialog-action-buttons">
                                <v-col cols="12" sm="6">
                                    <v-btn block color="error" :disabled="saving" @click="cancelEditSupplier">Cancel</v-btn>
                                </v-col>

                                <v-col cols="12" sm="6">
                                    <v-btn block color="success" :disabled="!editSupplierValid" :loading="saving" @click="saveEditedSupplier">Save</v-btn>
                                </v-col>

                                <v-col cols="12" v-if="validationError">
                                    <v-alert text type="error">{{ validationError }}</v-alert>
                                </v-col>
                                <v-col cols="12" v-else-if="saveError">
                                    <v-alert text type="error">{{ saveError }}</v-alert>
                                </v-col>
                            </v-row>                            
                        </v-col>
                    </v-row>
                </v-form>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import validationRules from "../../helpers/validationrules";
import * as auth from '@/services/auth';
import { mapGetters } from 'vuex';

export default {
    components: {
    },
    props: [
        
    ],
    data() {
        return {
            auth: auth,
            activeOnly: true,
            showSpecimenSuppliers: true,
            showVenomSuppliers: true,
            editedSupplier: {},
            showEditDialog: false,
            editSupplierValid: false,
            rules: validationRules.rules,
            validationError: null,
            footerProps: {
                'items-per-page-options': [5, 20, 50, 100]
            },
            pagination: {
                rowsPerPage: 20, // default
                sortBy: "SupplierName",
                descending: true,
                page: 1
            },
            headers: [
                {
                    text: "Supplier Name",
                    value: "SupplierName"
                },
                {
                    text: "Geographical Location",
                    value: "GeographicalLocationName"
                },
                {
                    text: "Comments",
                    value: "MiscComments",
                    sortable: false,
                },
                {
                    text: "Supplies Specimens",
                    value: "IsSpecimenSupplier"
                },
                {
                    text: "Supplies Venom",
                    value: "IsVenomSupplier"
                },
                {
                    text: "Active",
                    value: "Active"
                },
                {
                    text: "", // edit button
                    value: "Edit",
                    sortable: false,
                    width: "100px"
                }
            ]
        };
    },
    computed: {
        loading() {
            return this.$store.state.supplierStore.loading || this.$store.state.locationStore.loading;
        },
        loadError() {
            return this.$store.state.supplierStore.loadError;
        },
        saving() {
            return this.$store.state.supplierStore.saving;
        },
        saveError() {
            return this.$store.state.supplierStore.saveError;
        },
        suppliers() {
            return this.$store.state.supplierStore.suppliers
                .filter(s => (s.Active || !this.activeOnly))
                .filter(s => (this.showSpecimenSuppliers && s.IsSpecimenSupplier) || (this.showVenomSuppliers && s.IsVenomSupplier));
        },
        ...mapGetters({
            geographicLocations: "locationStore/geographicLocations",
        })
    },
    methods: {
        isVenomSupplierChanged() {
            // show which fields are mandatory when changing which fields are displayed
            this.$nextTick(() => this.$refs.editForm.validate());
        },
        editSupplier(item) {
            this.$store.dispatch("supplierStore/clearSaveError");

            this.editedSupplier = Object.assign({}, item);

            this.showEditDialog = true;

            // show which fields are mandatory when opening the edit form
            this.$nextTick(() => this.$refs.editForm.validate());
        },
        cancelEditSupplier() {
            this.showEditDialog = false;
            this.editedSupplier = {};
        },
        formPassesExtraValidation() {
            this.validationError = null;

            // must select at least one of the 2 options
            if (this.editedSupplier.IsVenomSupplier || this.editedSupplier.IsSpecimenSupplier) {

            }
            else {
                this.validationError = "Supplier must supply specimens, venom, or both";
                return false;
            }

            // must enter at least one of the contact fields (other than the name)
            if (this.editedSupplier.ContactNumber || this.editedSupplier.ContactEmail || this.editedSupplier.SupplierAddress) {

            }
            else if (!this.editedSupplier.IsVenomSupplier) {

            }
            else {
                this.validationError = "Supplier must have at least one contact option: number, email, or address";
                return false;
            }

            return true;
        },
        clearEditedVenomFields() {
            if (this.editedSupplier.IsVenomSupplier) {

            }
            else {
                // not a venom supplier? make sure we do not submit any of the venom fields to the server
                this.editedSupplier.ContactName = null;
                this.editedSupplier.ContactNumber = null;
                this.editedSupplier.ContactEmail = null;
                this.editedSupplier.SupplierAddress = null;
            }
        },
        removeNotRequiredFields() {
            delete this.editedSupplier.GeographicalLocationName;
        },
        saveEditedSupplier() {
            var that = this;

            if (!this.formPassesExtraValidation()) {
                return;
            }

            this.clearEditedVenomFields();
            this.removeNotRequiredFields();

            if(this.editedSupplier.GeographicalLocationID == undefined){
                this.editedSupplier.GeographicalLocationID = null;
            }

            this.$store.dispatch("supplierStore/saveSupplier", {
                supplier: this.editedSupplier,
                finally: function() {
                    if (that.$store.state.supplierStore.saveError) {
                        // do not close the dialog
                        // display the error
                    }
                    else {
                        // close the dialog
                        that.cancelEditSupplier();
                    }
                }
            });
        }
    },
    created() {
        this.$store.dispatch("supplierStore/loadSuppliers");
        this.$store.dispatch("locationStore/loadGeographicLocations");
    }
};
</script>

<style>
    .commentColumn {
        max-width: 25vw;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }
</style>